/**
 * Dashboard API fetcher (D-35).
 *
 * Fetches aggregated dashboard stats from GET /v1/dashboard/stats
 * and validates the response against the shared DashboardStatsResponse schema.
 */
import { api } from './client';
import {
  DashboardStatsResponse,
  type DashboardStats,
} from '@acc/shared/schemas/dashboard.schema';

export async function fetchDashboardStats(): Promise<DashboardStats> {
  const raw = await api.get('dashboard/stats').json();
  return DashboardStatsResponse.parse(raw);
}
